import { getSlideTitle } from "./getSlideTitle";
import { noMessagesSlide } from "./noMessagesSlide";

export const formatPolicyAlertsResponseToCarouselFriendly = (
  response,
  policies
) => {
  if (
    !response?.success ||
    response?.gIdpPayLoad?.policyHolder?.alerts?.length === 0
  )
    return [noMessagesSlide];

  const firstFivePoliciesCompleteAlertList = [];
  for (let i = 0; i < response?.gIdpPayLoad?.policyHolder?.alerts.length; i++) {
    const policyMessages = response?.gIdpPayLoad?.policyHolder?.alerts[i];

    const messagesToSlide = policyMessages?.messages?.map((policyAlert) => ({
      ...policyAlert,
      policyNumber: policyMessages?.policy,
      memberID: policyMessages?.memberID,
      iconBorder: "ui-icon-border-good",
      title: getSlideTitle(policyMessages, policies),
      detail: policyAlert?.message,
    }));

    firstFivePoliciesCompleteAlertList.push(...messagesToSlide);
  }

  return firstFivePoliciesCompleteAlertList;
};
